export default __webpack_public_path__ + "static/media/photo_5282747746622312889_y.c54ac584.jpg";